;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { cn } from '@workspace/ui/lib';
import { forwardRef } from 'react';

interface SentinelProps {
  className?: string;
  style?: React.CSSProperties;
}

/**
 * A sentinel element used with IntersectionObserver for detecting visibility.
 * Commonly used for infinite scroll implementations.
 *
 * @example
 * const sentinelRef = useIntersectionObserver({
 *   onIntersect: (isVisible) => {
 *     if (isVisible) fetchNextPage();
 *   }
 * });
 *
 * return (
 *   <div>
 *     {items.map(...)}
 *     <Sentinel ref={sentinelRef} />
 *   </div>
 * );
 */
export const Sentinel = forwardRef<HTMLDivElement, SentinelProps>(({ className, style }, ref) => {
  return (
    <div
      ref={ref}
      className={cn('h-px w-full', className)}
      style={style}
      aria-hidden="true"
      data-sentinel
    />
  );
});

Sentinel.displayName = 'Sentinel';
